import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { getErrorFormat } from 'core/utils/errors';

const getUrl = ({ host, gatewayId, assetId }: { host: string; gatewayId: string; assetId: string }): string => {
  return `${host}/assets/${assetId}/gateways/${gatewayId}`;
};

export const AssignGatewayToAsset = async ({
  host,
  token,
  gatewayId,
  assetId,
}: {
  host: string;
  token: string;
  gatewayId: string;
  assetId: string;
}): Promise<void> => {
  try {
    const url = getUrl({ host, gatewayId, assetId });

    const options: AxiosRequestConfig = {
      url,
      method: 'PATCH',
      timeout: 10000,
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json;charset=UTF-8',
        Authorization: token,
        'Accept-version': '1',
      },
    };

    const { data } = (await axios(options)) as AxiosResponse<void>;
    return data;
  } catch (error) {
    throw getErrorFormat(error);
  }
};
